import {Injectable} from '@angular/core';
import {AccountService} from './account.service';
import {AuthServerProvider} from './auth-jwt.service';
import {JhiTrackerService} from './tracker.service';
import {Account} from '../model/account.model';

@Injectable({providedIn: 'root'})
export class LoginService {
    account: Account;

    constructor(
        private accountService: AccountService,
        private trackerService: JhiTrackerService,
        private authServerProvider: AuthServerProvider
    ) {
    }

    login(credentials, callback?) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const cb = callback || (() => {
        });

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(
                (data) => {
                    this.accountService.identity(true).then((account) => {
                        sessionStorage.setItem('account', JSON.stringify(account));
                        this.trackerService.sendActivity();
                        resolve(data);
                    });
                    return cb();
                },
                (err) => {
                    this.logout();
                    reject(err);
                    return cb(err);
                }
            );
        });
    }

    isAuthenticated() {
        return this.accountService.isAuthenticated();
    }

    logoutDirectly() {
        this.accountService.authenticate(null);
    }

    logout() {
        if (this.accountService.isAuthenticated()) {
            this.authServerProvider
                .logout()
                .subscribe(() => this.accountService.authenticate(null));
        } else {
            this.accountService.authenticate(null);
        }
        // this.dmpWebsocketService.disconnect();
        localStorage.clear();
    }

    getAccount(): Account {
        return JSON.parse(sessionStorage.getItem('account'));
    }
}
